"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var cov_1bgi6dqrde = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/BlobObject.js";
  var hash = "4b612dcbd03739aa86d922451d5b1f2f3f85a73d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/BlobObject.js",
    statementMap: {
      "0": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 51
        }
      },
      "1": {
        start: {
          line: 34,
          column: 16
        },
        end: {
          line: 34,
          column: 46
        }
      },
      "2": {
        start: {
          line: 36,
          column: 15
        },
        end: {
          line: 38,
          column: 20
        }
      },
      "3": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 57,
          column: 4
        }
      },
      "4": {
        start: {
          line: 46,
          column: 22
        },
        end: {
          line: 46,
          column: 47
        }
      },
      "5": {
        start: {
          line: 46,
          column: 34
        },
        end: {
          line: 46,
          column: 47
        }
      },
      "6": {
        start: {
          line: 60,
          column: 0
        },
        end: {
          line: 80,
          column: 2
        }
      },
      "7": {
        start: {
          line: 82,
          column: 0
        },
        end: {
          line: 85,
          column: 2
        }
      },
      "8": {
        start: {
          line: 87,
          column: 15
        },
        end: {
          line: 94,
          column: 2
        }
      },
      "9": {
        start: {
          line: 87,
          column: 25
        },
        end: {
          line: 94,
          column: 1
        }
      },
      "10": {
        start: {
          line: 96,
          column: 26
        },
        end: {
          line: 96,
          column: 65
        }
      }
    },
    fnMap: {
      "0": {
        name: "BlobObjectComponent",
        decl: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 28
          }
        },
        loc: {
          start: {
            line: 32,
            column: 3
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 46,
            column: 15
          },
          end: {
            line: 46,
            column: 16
          }
        },
        loc: {
          start: {
            line: 46,
            column: 21
          },
          end: {
            line: 46,
            column: 48
          }
        },
        line: 46
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 87,
            column: 15
          },
          end: {
            line: 87,
            column: 16
          }
        },
        loc: {
          start: {
            line: 87,
            column: 25
          },
          end: {
            line: 94,
            column: 1
          }
        },
        line: 87
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 30
          },
          end: {
            line: 33,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 30
          },
          end: {
            line: 33,
            column: 38
          }
        }, {
          start: {
            line: 33,
            column: 42
          },
          end: {
            line: 33,
            column: 44
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 15
          },
          end: {
            line: 38,
            column: 20
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 12
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 20
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 22
          },
          end: {
            line: 46,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 22
          },
          end: {
            line: 46,
            column: 47
          }
        }, {
          start: {
            line: 46,
            column: 22
          },
          end: {
            line: 46,
            column: 47
          }
        }],
        line: 46
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "4b612dcbd03739aa86d922451d5b1f2f3f85a73d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlobObject = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _path = _interopRequireDefault(require("path"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A Blob Component to render a Git Tree blob object.
 */


function BlobObjectComponent(_ref) {
  var classes = _ref.classes,
      selected = _ref.selected,
      blob = _ref.blob,
      _ref$blob = _ref.blob,
      path = _ref$blob.path,
      url = _ref$blob.url,
      size = _ref$blob.size,
      onBlob = _ref.onBlob,
      depth = _ref.depth,
      filepath = _ref.filepath;
  cov_1bgi6dqrde.f[0]++;

  var _filepath = (cov_1bgi6dqrde.s[0]++, _path.default.join((cov_1bgi6dqrde.b[0][0]++, filepath) || (cov_1bgi6dqrde.b[0][1]++, ''), path));

  var _blob = (cov_1bgi6dqrde.s[1]++, _objectSpread({}, blob, {
    filepath: _filepath
  }));

  var icon = (cov_1bgi6dqrde.s[2]++, selected ? (cov_1bgi6dqrde.b[1][0]++, _react.default.createElement(_icons.Note, null)) : (cov_1bgi6dqrde.b[1][1]++, _react.default.createElement(_icons.NoteOutlined, null)));
  cov_1bgi6dqrde.s[3]++;
  return _react.default.createElement(_core.ListItem, {
    button: true,
    selected: selected,
    className: classes.root,
    style: {
      paddingLeft: depth + 'em'
    },
    onClick: function onClick() {
      cov_1bgi6dqrde.f[1]++;
      cov_1bgi6dqrde.s[4]++;

      if (onBlob) {
        cov_1bgi6dqrde.b[2][0]++;
        cov_1bgi6dqrde.s[5]++;
        onBlob(_blob);
      } else {
        cov_1bgi6dqrde.b[2][1]++;
      }
    }
  }, _react.default.createElement(_core.ListItemIcon, {
    style: {
      marginRight: 0
    }
  }, icon), _react.default.createElement(_core.ListItemText, {
    className: classes.pathText,
    primary: path,
    secondary: (0, _helpers.humanFileSize)(size)
  }));
}

cov_1bgi6dqrde.s[6]++;
BlobObjectComponent.propTypes = {
  /** @ignore */
  classes: _propTypes.default.object.isRequired,

  /** Blob data to render, if url not provided. */
  blob: _propTypes.default.shape({
    /** The filepath in the Git Tree Blob Object */
    path: _propTypes.default.string.isRequired,

    /** The url in the Git Tree Blob Object */
    url: _propTypes.default.string,

    /** The content size of the Git Tree Blob Object */
    size: _propTypes.default.number
  }),

  /** Set whether or not the File object is currently selected. */
  selected: _propTypes.default.bool,

  /** Function to propogate when the Blob is selected. */
  onBlob: _propTypes.default.func,

  /** The depth of the path in the tree sets the inset of the component. */
  depth: _propTypes.default.number,

  /** The nested filepath that will concatenate. */
  filepath: _propTypes.default.string
};
cov_1bgi6dqrde.s[7]++;
BlobObjectComponent.defaultProps = {
  selected: false,
  depth: 1
};
cov_1bgi6dqrde.s[8]++;

var styles = function styles(theme) {
  cov_1bgi6dqrde.f[2]++;
  cov_1bgi6dqrde.s[9]++;
  return {
    root: {
      paddingRight: '0.7em'
    },
    pathText: {
      paddingLeft: '0.7em'
    }
  };
};

var BlobObject = (cov_1bgi6dqrde.s[10]++, (0, _styles.withStyles)(styles)(BlobObjectComponent));
exports.BlobObject = BlobObject;